<template>
    <svg width="80" height="74" viewBox="0 0 80 74" xmlns="http://www.w3.org/2000/svg">
        <path d="M80 0v33.957c0 21.75-17.908 39.376-40 39.376S0 55.704 0 33.957V0h80zM47.3 27.368a5.223 5.223 0 0 0-4.206-.995 4.938 4.938 0 0 0-3.716 2.695c-.078.152-.139.311-.208.468-.01-.006-.017-.009-.023-.014a4.662 4.662 0 0 0-1.621-2.171 5.457 5.457 0 0 0-5.09-.745 4.882 4.882 0 0 0-2.933 2.729 4.82 4.82 0 0 0-.231 2.833 8.153 8.153 0 0 0 1.159 2.84 16.24 16.24 0 0 0 2.409 2.922 29.677 29.677 0 0 0 3.442 2.91c.759.55 1.515 1.107 2.272 1.66l.616.447c.47-.343.933-.68 1.394-1.019.972-.715 1.976-1.392 2.893-2.171a49.963 49.963 0 0 0 1.933-1.724 16.32 16.32 0 0 0 2.024-2.294 8.514 8.514 0 0 0 1.705-3.956 4.943 4.943 0 0 0-.027-1.561 4.548 4.548 0 0 0-1.793-2.854z" fill="#F796A1" fill-rule="nonzero"/>
    </svg>
</template>

<script>
export default {
    name: 'IconFavoritePin',
};
</script>
